module.exports = __webpack_public_path__ + "img/index_group1.a0e70066.png";